export default __webpack_public_path__ + "static/media/Condizionigeneralidiacquisto.895e3653.png";